export default "__VITE_ASSET__f55ce82d__"